<div id="home">
  <header>
    <nav class="navbar nav-bar-programs">
      <div class="container">
        <a class="navbar-brand main-logo" routerLink="/">
          <img alt="IPDJ" class="logo-programa" src="/content/images/brand/ipdj.png" />
        </a>
      </div>
    </nav>
    <div class="container main-banner">JUVENTUDE</div>
  </header>

  <section *ngIf="homeInfo" class="programas" style="margin-bottom: 100px">
    <div class="container-fluid" style="text-align: center">
      <p class="title" style="margin-bottom: 33px">PROGRAMAS</p>
      <div class="d-flex row justify-content-center">
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas agoraNos" routerLink="agora-nos">
          <div class="logo-programas" style="">
            <img alt="agoraNos" class="logo" src="/content/images/home/logo-agoraNos.png?cache=20250204" />
            <img alt="agoraNos" class="inv" src="/content/images/home/logo-agoraNos-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title">Agora Nós</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.agoraNosDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.agoraNosDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-agoranos">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas geracaoz" routerLink="geracaoz">
          <div class="logo-programas" style="">
            <img alt="" class="logo" src="/content/images/home/logo-geracaoz.png?cache=20250204" />
            <img alt="" class="inv" src="/content/images/home/logo-geracaoz-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-geracaoz">Geração Z</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.geracaoZDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.geracaoZDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-geracaoz">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas namorar" routerLink="namorar-com-fair-play">
          <div class="logo-programas" style="">
            <img alt="" class="logo" src="/content/images/home/logo-namorar.png?cache=20250204" />
            <img alt="" class="inv" src="/content/images/home/logo-namorar-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-namorar">Namorar com Fair Play</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.namorarDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.namorarDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-namorar">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas navegas" routerLink="navegas-em-seguranca">
          <div class="logo-programas" style="">
            <img alt="" class="logo" src="/content/images/home/logo-navegas.png?cache=20250204" />
            <img alt="" class="inv" src="/content/images/home/logo-navegas-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-navegas">Navega(s) em segurança</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.navegasDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.navegasDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-navegas">Saber mais</div>
        </a>
      </div>
      <div class="d-flex row justify-content-center">
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas florestas" routerLink="vjnf">
          <div class="logo-programas" style="">
            <img alt="florestas" class="logo" src="/content/images/home/logo-florestas.png?cache=20250204" />
            <img alt="florestas" class="inv" src="/content/images/home/logo-florestas-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-florestas">Voluntariado Jovem para a Natureza e Florestas</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.florestasDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.florestasDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-florestas">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas cti" routerLink="cti">
          <div class="logo-programas" style="">
            <img alt="cti" class="logo" src="/content/images/home/logo-cti.png?cache=20250204" />
            <img alt="cti" class="inv" src="/content/images/home/logo-cti-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-cti">Campos de Trabalho Internacionais</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.ctiDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.ctiDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-cti">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas ferias" routerLink="ferias">
          <div class="logo-programas" style="">
            <img alt="ferias" class="logo" src="/content/images/home/logo-ferias.png?cache=20250204" />
            <img alt="ferias" class="inv" src="/content/images/home/logo-ferias-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-ferias">Férias em Movimento</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.feriasDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.feriasDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-ferias">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas otl" routerLink="otl">
          <div class="logo-programas" style="">
            <img alt="otl" class="logo" src="/content/images/home/logo-otl.png?cache=20250204" />
            <img alt="otl" class="inv" src="/content/images/home/logo-otl-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-otl">Ocupação de Tempos Livres</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.otlDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.otlDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-otl">Saber mais</div>
        </a>
      </div>
      <div class="d-flex row justify-content-center">
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas cuidate2" routerLink="cuida-te">
          <div class="logo-programas" style="">
            <img alt="cuidate2" class="logo" src="/content/images/home/logo-cuidate2.png?cache=20250204" />
            <img alt="cuidate2" class="inv" src="/content/images/home/logo-cuidate2-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-cuidate2">Cuida-te</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.cuidate2DescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.cuidate2DescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-cuidate2">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas workCampRegistration" routerLink="workCampRegistration">
          <div class="logo-programas" style="">
            <img alt="registo entidades" class="logo" src="/content/images/home/logo-workCampRegistration.png?cache=20250204" />
            <img alt="registo entidades" class="inv" src="/content/images/home/logo-workCampRegistration-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-workCampRegistration">Registo Entidades Organizadoras Campo de Férias</p>
              <p
                *ngIf="currentLanguage == 'pt-pt'"
                [innerHTML]="getDescription(homeInfo.workCampRegistrationDescriptionPT)"
                class="boxed-text"
              ></p>
              <p
                *ngIf="currentLanguage == 'en'"
                [innerHTML]="getDescription(homeInfo.workCampRegistrationDescriptionEN)"
                class="boxed-text"
              ></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-workCampRegistration">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas euroscola" routerLink="euroscola">
          <div class="logo-programas" style="">
            <img alt="euroscola" class="logo" src="/content/images/home/logo-euroscola.png?cache=20250204" />
            <img alt="euroscola" class="inv" src="/content/images/home/logo-euroscola-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-euroscola">Euroscola</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.euroscolaDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.euroscolaDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-euroscola">Saber mais</div>
        </a>
      </div>

      <div class="d-flex row justify-content-center">
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas passejovem" routerLink="passejovem">
          <div class="logo-programas" style="">
            <img alt="passeJovem" class="logo" src="/content/images/home/logo-passeJovem.png?cache=20250204" />
            <img alt="passeJovem" class="inv" src="/content/images/home/logo-passeJovem-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-passeJovem">Passe Jovem</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.passeJovemDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.passeJovemDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-passejovem">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas equality" routerLink="equality">
          <div class="logo-programas" style="">
            <img alt="jovens pela igualdade" class="logo" src="/content/images/home/logo-equality.png?cache=20250204" />
            <img alt="jovens pela igualdade" class="inv" src="/content/images/home/logo-equality-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-equality">Jovens pela Igualdade</p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.equalityDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.equalityDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-equality">Saber mais</div>
        </a>
        <a class="col-xs-12 col-sm-6 col-md-3 box-programas cuidate" routerLink="cuida_te">
          <div class="logo-programas" style="">
            <img alt="cuidate" class="logo" src="/content/images/home/logo-cuidate.png?cache=20250204" />
            <img alt="cuidate" class="inv" src="/content/images/home/logo-cuidate-inv.png?cache=20250204" />
          </div>
          <div class="box-text-prog">
            <div class="col-xs-24">
              <p class="boxed-title color-cuidate">
                Cuida-te <sup><b>+</b></sup>
              </p>
              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.cuidateDescriptionPT)" class="boxed-text"></p>
              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.cuidateDescriptionEN)" class="boxed-text"></p>
            </div>
          </div>
          <div class="btn-pg saber-mais back-color-cuidate">Saber mais</div>
        </a>
      </div>
      <!--      <div class="d-flex row justify-content-center">-->
      <!--        <a class="col-xs-12 col-sm-6 col-md-3 box-programas soudigital" routerLink="geracoes-em-rede">-->
      <!--          <div class="logo-programas" style="">-->
      <!--            <img alt="" class="logo" src="/content/images/home/logo-soudigital.png?cache=20250204" />-->
      <!--            <img alt="" class="inv" src="/content/images/home/logo-soudigital-inv.png?cache=20250204" />-->
      <!--          </div>-->
      <!--          <div class="box-text-prog">-->
      <!--            <div class="col-xs-24">-->
      <!--              <p class="boxed-title color-soudigital">Gerações em Rede</p>-->
      <!--              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.soudigitalDescriptionPT)" class="boxed-text"></p>-->
      <!--              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.soudigitalDescriptionEN)" class="boxed-text"></p>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="btn-pg saber-mais back-color-soudigital">Saber mais</div>-->
      <!--        </a>-->
      <!--        <a class="col-xs-12 col-sm-6 col-md-3 box-programas setentaja" routerLink="70-ja">-->
      <!--          <div class="logo-programas" style="">-->
      <!--            <img alt="" class="logo" src="/content/images/home/logo-setentaja.png?cache=20250204" />-->
      <!--            <img alt="" class="inv" src="/content/images/home/logo-setentaja-inv.png?cache=20250204" />-->
      <!--          </div>-->
      <!--          <div class="box-text-prog">-->
      <!--            <div class="col-xs-24">-->
      <!--              <p class="boxed-title color-setentaja">Voluntariado Jovem 70 Já – Direitos da Juventude</p>-->
      <!--              <p *ngIf="currentLanguage == 'pt-pt'" [innerHTML]="getDescription(homeInfo.setentajaDescriptionPT)" class="boxed-text"></p>-->
      <!--              <p *ngIf="currentLanguage == 'en'" [innerHTML]="getDescription(homeInfo.setentajaDescriptionEN)" class="boxed-text"></p>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="btn-pg saber-mais back-color-setentaja">Saber mais</div>-->
      <!--        </a>-->
      <!--      </div>-->
    </div>
  </section>

  <section *ngIf="hasNews()" class="noticias text-center">
    <p class="title" style="font-weight: lighter; margin-bottom: 33px">NOTÍCIAS</p>
    <div class="container news-wrapper">
      <div class="row">
        <div *ngFor="let news of homeInfo?.news" [routerLink]="['/news', news.id]" class="col col-lg-3">
          <div class="box">
            <div
              class="boxed-image"
              style="background-image: url({{ 'data:' + news.imageSmallContentType + ';base64,' + news.imageSmall }})"
            >
              <span *ngIf="!news.imageSmallContentType">{{ news.titlePT }}</span>
            </div>
            <img [src]="'/content/images/home/mini-' + news.programEnum + '.png'" alt="logo" class="mini-logo" />
            <div class="box-text">
              <div class="col-xs-24">
                <p class="boxed-title color-ferias">
                  {{ news.titlePT }}
                </p>
                <p class="boxed-text">{{ getNewsDescription(news) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="noticias text-center">
    <p class="title" style="font-weight: lighter; margin-bottom: 33px" [routerLink]="['/tutorials']">
      <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
      TUTORIAIS
    </p>
  </section>
</div>
